import { render, staticRenderFns } from "./ProductQuery.vue?vue&type=template&id=45ecd8a4&scoped=true"
import script from "./ProductQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductQuery.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ecd8a4",
  null
  
)

export default component.exports